export default "__VITE_ASSET__bh7KFPEe__"